<template>
  <div class="rubrics-view-container w-100">
    <div
      class="d-flex justify-content-between align-items-center p-4 rubrics-library-header"
    >
      <h1 class="heading-m m-0">{{ $t("rubrics.title") }}</h1>
      <div class="d-flex flex-gap-1">
        <eg-button type="secondary" to="/" icon="scratch">
          {{ $t("rubrics.startGrading") }}
        </eg-button>
        <create-rubric-dropdown />
      </div>
    </div>
    <eg-tabs
      v-model="activeTab"
      class="rubrics-tabs"
      data-testid="rubrics-tabs"
      no-fade
    >
      <eg-b-tab
        :title="$t('rubrics.platformRubrics')"
        title-item-class="rubrics-tabs-platform"
      >
        <rubric-view-table rubric-type="platform" />
      </eg-b-tab>

      <eg-b-tab
        :title="$t('rubrics.myRubrics')"
        title-item-class="rubrics-tabs-my-rubric"
      >
        <rubric-view-table rubric-type="my" />
      </eg-b-tab>

      <eg-b-tab
        :title="$t('rubrics.sharedRubrics')"
        :disabled="sharedRubrics.length === 0"
      >
        <rubric-view-table v-model="sharedRubrics" rubric-type="shared" />
      </eg-b-tab>
    </eg-tabs>
  </div>
</template>
<script>
import RubricViewTable from "@/components/rubrics/rubric_view_table.vue";
import CreateRubricDropdown from "@/components/rubrics/components/create_rubric_dropdown.vue";

export default {
  name: "RubricsView",

  components: {
    RubricViewTable,
    CreateRubricDropdown,
  },

  data() {
    return {
      sharedRubrics: [],
      activeTab: 0,
    };
  },

  async mounted() {
    // Listen for rubric creation events to switch to "My rubrics" tab
    this.$eventBus.$on("rubric-created", this.rubricCreatedHandler);

    const { openCreateRubric, ...queryParams } = this.$route.query;
    if (openCreateRubric) {
      this.$nextTick(() => {
        this.openCreateRubricDropdown();
        this.$router.replace({ query: queryParams });
      });
    }
  },

  beforeDestroy() {
    this.$eventBus.$off("rubric-created", this.rubricCreatedHandler);
  },

  methods: {
    openCreateRubricDropdown() {
      const createButton = this.$el.querySelector(
        '[data-testid="rubric-library-create-new-rubric-button"]'
      );
      if (createButton) {
        createButton.click();
      }
    },

    rubricCreatedHandler() {
      // Handle both old format (direct rubric) and new format ({ rubric, isCreating })
      // Switch to "My rubrics" tab when rubric is created or edited
      this.activeTab = 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.rubrics-view-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background-color: white;
}
.rubrics-library-header {
  background-color: var(--color-surface-neutral-canvas);
  flex-shrink: 0;
}

.rubrics-tabs {
  background-color: white;

  &::v-deep {
    .eg-tabs__container {
      overflow: visible !important;
    }
  }
}
</style>

<style lang="scss">
.eg-rubric-modal .eg-modal__container {
  .eg-modal__body:last-child {
    padding: 0;
    overflow: hidden;
  }
  .rubric-form-body,
  .rubric-form-content {
    height: calc(85vh - 190px);
  }
  .rubric-form-body {
    padding: 0;
    overflow: hidden;
  }
  .rubric-form-content {
    padding: 24px;
    overflow-y: auto;
  }
}
.rubrics-view-container
  .b-table-sticky-header
  > .table.b-table
  > thead
  > tr
  > th {
  top: calc(48px + 54px);
}

.rubrics-tabs .tabs > div:has(ul.nav-tabs) {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: var(--color-surface-neutral-canvas);
}

.rubrics-tabs .eg-tabs__container {
  overflow: visible !important;
}

.rubrics-tabs .tab-content {
  overflow: visible !important;
}

.rubrics-table .eg-table-base-filters {
  position: sticky !important;
  top: 37px;
  background-color: var(--color-surface-neutral-background);
  z-index: 3;
}
</style>
